import { Index } from "./index";
import { Site } from "./site";
import { Address } from "./address";
import { Company } from "./company";
import { ContractType } from "./contract-type";
import { ContractType as ContractTypeEnum, NameToContractType } from "@enums/contract-type.enum";

export class Contract {
    id?: string;
    comment?: string;
    dateBegin?: Date | string;
    dateEnd?: Date | string;
    dateStartBilling?: Date | string;
    quantityMin?: number;
    sliceDegressiveness?: number;
    index?: Index;
    indexId?: string;
    billingName?: string;
    billingAddress?: Address;
    billingAddressId?: string | null;
    billingEmail?: string;
    siteId?: string | null;
    site?: Site;
    companyId?: string | null;
    company?: Company;
    contractTypeId?: string | null;
    contractType?: ContractType;
    contractTypeEnum?: ContractTypeEnum;
    // isFittedOutArea?: boolean | string;
    // isGoodAccessibility?: boolean | string;
    isPunctualHandling?: boolean | string;
    // zone?: string | null;

    constructor(contract?: Contract) {
        this.id = contract?.id;
        this.dateBegin = contract?.dateBegin;
        this.dateEnd = contract?.dateEnd;
        this.dateStartBilling = contract?.dateStartBilling;
        this.quantityMin = contract?.quantityMin;
        this.sliceDegressiveness = contract?.sliceDegressiveness;
        this.index = contract?.index;
        this.indexId = contract?.indexId;
        this.billingName = contract?.billingName;
        this.billingAddress = contract?.billingAddress;
        this.billingAddressId = contract?.billingAddressId || (contract?.billingAddress ? contract?.billingAddress.id : null);
        this.billingEmail = contract?.billingEmail;
        this.siteId = contract?.siteId || (contract?.site ? contract?.site.id : null);
        this.site = contract?.site;
        this.comment = contract?.comment;
        this.companyId = contract?.companyId || (contract?.company ? contract?.company.id : null);
        this.company = contract?.company;
        this.contractTypeId = contract?.contractTypeId || (contract?.contractType ? contract?.contractType.id : null);
        this.contractType = contract?.contractType;
        this.contractTypeEnum = contract?.contractTypeEnum;
        // this.isFittedOutArea = (typeof contract?.isFittedOutArea == "string")
        //     ? ((contract?.isFittedOutArea || "").toLowerCase() == "true")
        //     : contract?.isFittedOutArea;
        // this.isGoodAccessibility = (typeof contract?.isGoodAccessibility == "string")
        //     ? ((contract?.isGoodAccessibility || "").toLowerCase() == "true")
        //     : contract?.isGoodAccessibility;
        this.isPunctualHandling = (typeof contract?.isPunctualHandling == "string")
            ? ((contract?.isPunctualHandling || "").toLowerCase() == "true")
            : contract?.isPunctualHandling;
        // this.zone = contract?.zone;
    }
}
